import { AuthorizationRole } from "./AuthorizationRole";
import { IFlock } from "./Flock";

export interface IFarmUser {
	id: string;
	name: string;
	role: AuthorizationRole;
	sampleReminderBan: boolean | null | undefined;
}

export interface IFarmNoFlocks {
	id: string;
	customerId: string;
	name: string;
	type: FarmType;
	users: IFarmUser[];
	streetAddress: string;
	zipCode: string;
	postOffice: string;
	hasEndedFlocks?: boolean;
	hasSamplesWithResults: boolean;
	locationCode?: string;
}

export interface IFarm extends IFarmNoFlocks {
	flocks: IFlock[];
	canAccessControlVisits: boolean;
	canDelete: boolean;
}

export enum FarmType {
	Henhouse = "Henhouse",
	Hatchery = "Hatchery",
}

export function isHenhouse(farm: IFarm) {
	return farm.type === FarmType.Henhouse;
}

export function isHatchery(farm: IFarm) {
	return farm.type === FarmType.Hatchery;
}
